import  MyCoursePage from '../../pages/Course/myCourse';
import MarketplaceIndexPage from '../../pages/Marketplace/index'
import CompanyIndexPage from '../../pages/company/index'
import CompanyViewPage from '../../pages/company/view'
import CompanyEditPage from '../../pages/company/edit'
import CourseIntroPage from '../../pages/Marketplace/detail'
import CoursePage from '../../pages/courses/searchList';
import CourseDetailPage from '../../pages/courses/detail';
import AboutUs from '../../pages/content/about-us';
import HowBenefits from '../../pages/content/how-benefits';
import HowItWorks from '../../pages/content/how-it-works';
import TermsOfUse from '../../pages/content/terms-of-use';
import PrivacyPolicy from '../../pages/content/privacy-policy';
import ContactUs from '../../pages/content/contact-us';
import Help from '../../pages/content/help';
import FAQ from '../../pages/content/faq';

import ForgotPassword from '../public/ForgotPassword';
export default {
    Home: {
        component: MyCoursePage,
        path: '/'
    },
    // Marketplace: {
    //     component: MarketplaceIndexPage,
    //     path: '/Marketplace'
    // },
    // CourseIntro:{
    //     component: CourseIntroPage,
    //     path: '/intro/:id'
    // },
    HowBenefits: {
        component: HowBenefits,
        path: '/how-we-benefits-you'
    },
    HowItWorks: {
        component: HowItWorks,
        path: '/how-it-works'
    },
    TermsOfUse: {
        component: TermsOfUse,
        path: '/terms-of-use'
    },
    PrivacyPolicy: {
        component: PrivacyPolicy,
        path: '/privacy-policy'
    },
    Help: {
        component: Help,
        path: '/help'
    },
    FAQ: {
        component: FAQ,
        path: '/faq'
    },
    AboutUs: {
        component: AboutUs,
        path: '/about-us'
    },
    ContactUs: {
        component: ContactUs,
        path: '/contact-us'
    },
    Courses: {
        component: CoursePage,
        path: '/courses'
    },
    CourseIntro:{
        component: CourseDetailPage,
        path: '/courses/:id'
    },
    Companies: {
        component: CompanyIndexPage,
        path: '/Company/CompanyListing'
    },
    Company:{
        component: CompanyViewPage,
        path: '/Company/Company/:id'
    },
    EditCompany:{
        component: CompanyEditPage,
        path: '/Company/EditCompany/:id'
    },
    ForgotPasswordedback:{
        component: ForgotPassword,
        path: '/forgotPassword'
    }
};